<template>
  <ReviewsBlock
    v-if="productResponse && ratesResponse?.count"
    id="reviews"
    :ai-summary="reviewsAISummary"
    :ai-summary-pending="reviewsAiSummaryPending"
    class="mb-56"
    :merchant-id="selectedOffer?.merchant?.merchantId"
    :merchant-url="selectedOffer?.merchant?.merchantUrl"
    :next-reviews-cursor="reviewsResponse?.nextCursor"
    :pending-summary="ratingDetailsSummaryPending"
    :previous-reviews-cursor="reviewsResponse?.previousCursor"
    :product-id="productResponse.productId"
    :product-title="productResponse.titles.default"
    :rating="ratesResponse"
    :rating-summary="ratingDetailsSummaryResponse"
    :reviews="reviewsResponse?.results || []"
    :reviews-pending
    :tracking-info="productTracking.product.value"
  />
</template>

<script setup lang="ts">
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductTracking } from '~/scopes/product-core/composables/useFetch/useFetchProductTracking/useFetchProductTracking'
import { useFetchReviews } from '~/scopes/product-core/composables/useFetch/useFetchReviews/useFetchReviews'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import { useReviewsAISummary as useFetchReviewsAISummary } from '~/scopes/reviews/ai-summary/composables/useReviewsAISummary'
import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'
import { useRatingDetailsSummary as useFetchRatingDetailsSummary } from '~/scopes/reviews/reviews-display/composables/useRatingDetailsSummary'

const { data: productResponse } = useFetchProduct()
const { selectedOffer } = useFetchPickers()
const { data: ratesResponse } = useFetchReviewsSummary()
const { pending: reviewsPending, data: reviewsResponse } = useFetchReviews()
const { data: productTracking } = useFetchProductTracking()

const {
  pending: ratingDetailsSummaryPending,
  data: ratingDetailsSummaryResponse,
} = useFetchRatingDetailsSummary()
const { pending: reviewsAiSummaryPending, data: reviewsAISummary } =
  useFetchReviewsAISummary()
</script>
